<template>
    <v-row justify="center">
        <v-dialog
                v-model="dialog"
                persistent
                max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ pin.title }}</span>
                </v-card-title>
                <v-card-subtitle>
                    {{ pin.description }}
                </v-card-subtitle>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                        v-model="inputPin"
                                        label="Enter PIN code"
                                        type="password" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                            color="blue darken-1"
                            text
                            @click="closeDialog">
                        Close
                    </v-btn>
                    <v-btn
                            color="blue darken-1"
                            text
                            @click="confirm">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import crypto from "crypto"
    import Value from "../../../models/value.model";
	
    export default {
        name: "PinComponent",
        props: {
            pin: {type: Object, default: () => {}},
        },
        data() {
            return {
                dialog: false,
                confirmed: false,
                inputPin: '',
            }
        },
        methods: {
            openDialog() {
                this.dialog = true;
            },
            closeDialog() {
                this.dialog = false;
            },
            isConfirmed() {
                return this.confirmed;
            },
            setConfirmed() {
                this.confirmed = true;
                this.$emit('pinConfirmed', this.pin.id, new Value({
                    isValid: true,
                    isEmpty: false,
                    value: this.inputPin
                }));
            },
            confirm() {
                const hashedPin = crypto.createHash(this.pin.pin.algo).update(this.inputPin).digest('hex');
                if (hashedPin === this.pin.pin.value) {
                    this.setConfirmed();
                    this.closeDialog();
                } else {
                    this.$services.modals.alerts.error('PIN invalid');
                }
            },
        },
    }
</script>

<style scoped>

</style>